import { render } from "./TasksPage.vue?vue&type=template&id=247d6bfd&scoped=true"
import script from "./TasksPage.vue?vue&type=script&lang=js"
export * from "./TasksPage.vue?vue&type=script&lang=js"

import "./TasksPage.vue?vue&type=style&index=0&id=247d6bfd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247d6bfd"]])

export default __exports__